import { ceres_api } from "@/axios-config.js"

const Contact = {
    sendContact(payload) {
        return ceres_api.post("/contact/", payload)
    }
}

export default Contact
